@if (bucket(); as bucket) {
  <div class="bucket-setup-toolbar">
    <div class="bucket-setup-toolbar-content">
      <form [formGroup]="formGroup" #toolbarForm="ngForm" (ngSubmit)="finishSetup()">
        <div class="bucket-setup-toolbar-content-row">
          <app-ui-field
            class="bucket-setup-toolbar-field"
            [label]="amountLabel(bucket)"
            [inputId]="'bucket-setup-amount-' + bucket.id"
          >
            <app-ui-currency-input
              [inputId]="'bucket-setup-amount-' + bucket.id"
              name="amount"
              formControlName="amount"
              [disabled]="!!bucket.archivedMonth"
              (focused)="onFocus(formGroup.controls.amount)"
              (blurred)="onFocusOut(formGroup.controls.amount)"
            />
          </app-ui-field>
        </div>
        <div class="bucket-setup-toolbar-content-row">
          @if (bucket.type === 'SAVINGS') {
            <app-ui-field
              class="bucket-setup-toolbar-field"
              [label]="goalLabel()"
              [inputId]="'bucket-setup-goal-' + bucket.id"
            >
              <app-ui-currency-input
                [inputId]="'bucket-setup-goal-' + bucket.id"
                name="goal"
                formControlName="goal"
                [disabled]="!!bucket.archivedMonth"
                (focused)="onFocus(formGroup.controls.goal)"
                (blurred)="onFocusOut(formGroup.controls.goal)"
              />
            </app-ui-field>
          }

          <button appUiButton type="submit">Done</button>
        </div>
      </form>
    </div>
  </div>
}
